import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useToast } from "@/features/toast";
import { MAX_ATTACHMENTS } from "../config/support-config";

export const MAX_ATTACHMENT_SIZE_MB = 5;

/**
 * Görsel eki state'i + validasyonu — hem yeni talep formunda hem de
 * ticket cevap formunda kullanılır (max adet, tip ve boyut kontrolü).
 */
export const useImageAttachments = () => {
  const { t } = useTranslation();
  const { error } = useToast();
  const [attachments, setAttachments] = useState<File[]>([]);

  const addAttachments = (files: FileList | File[]) => {
    const incoming = Array.from(files);
    const next: File[] = [...attachments];

    for (const file of incoming) {
      if (next.length >= MAX_ATTACHMENTS) {
        error(t("support.attachments.maxFiles", { count: MAX_ATTACHMENTS }));
        break;
      }
      if (!file.type.startsWith("image/")) {
        error(t("support.attachments.imagesOnly"));
        continue;
      }
      if (file.size > MAX_ATTACHMENT_SIZE_MB * 1024 * 1024) {
        error(
          t("support.attachments.maxSize", { size: MAX_ATTACHMENT_SIZE_MB }),
        );
        continue;
      }
      next.push(file);
    }

    setAttachments(next);
  };

  const removeAttachment = (index: number) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };

  const clearAttachments = () => setAttachments([]);

  return {
    attachments,
    addAttachments,
    removeAttachment,
    clearAttachments,
    maxAttachments: MAX_ATTACHMENTS,
  };
};
